import { isDate, parse } from 'date-fns';
import { addMethod, date } from 'yup';

addMethod(date, 'dateTransform', function dateTransform(formatString = 'MM.yyyy') {
  return this.transform(function transform(value, originalValue) {
    const parsedDate = isDate(originalValue) ? originalValue : parse(originalValue, formatString, new Date());

    return parsedDate;
  });
});
